import { IMedia } from "../index";

export const instanceOfMedia = (object: any): object is IMedia => {
  if ((object as IMedia)?.id) {
    return true;
  }

  return false;
};
